import React from "react";

import styles from "./NavigationItems.module.css";
import NavigationItem from "./NavigationItem/NavigationItem";

const navigationItems = props => {
  return (
    <ul className={styles.NavigationItems}>
      {/* <NavigationItem link="/">Burger Builder</NavigationItem> */}
      <NavigationItem link="/nasa">Picture of The Day</NavigationItem>
      <NavigationItem link="/activity">User Activity</NavigationItem>
      <NavigationItem link="/live">Live Scores</NavigationItem>
      <NavigationItem link="/countries">Football</NavigationItem>
      <NavigationItem link="/about">About</NavigationItem>
      {/* {props.isAuthenticated ? (
        <NavigationItem link="/orders">Orders</NavigationItem>
      ) : null}
      {!props.isAuthenticated ? (
        <NavigationItem link="/auth">Authenticate</NavigationItem>
      ) : (
        <NavigationItem link="/logout">Log Out</NavigationItem>
      )} */}
    </ul>
  );
};

export default navigationItems;
